import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { AppStore } from '../../../AppStore';
import './Horoscopes.less';

const completelySynonyms = [
  "Totally",
  "Fully",
  "Entirely",
  "Absolutely",
  "Thoroughly",
  "Utterly",
  "Altogether",
  "Wholly",
  "Perfectly",
  "Downright",
  "Unquestionably",
  "Indisputably",
  "Flat-Out",
  "One Hundred Percent",
  "All The Way",
  "Every Bit",
  "Comprehensively",
  "Exhaustively",
  "Categorically",
  "Truly",
  "Genuinely",
  "Legitimately",
  "Veritably",
  "Definitely",
  "Positively",
  "Certainly",
  "Undoubtedly",
  "Seriously",
  "Straight-Up",
  "Beyond A Doubt",
  "In Every Way",
  "Without A Doubt",
  "Irrefutably",
  "Authentically",
  "Verifiably",
  "Demonstrably",
  "Palpably",
  "Obviously",
  "Clearly",
  "Evidently",
  "Manifestly",
  "Plainly",
  "Undeniably",
  "Unmistakably",
  "Visibly",
  "Apparently",
  "Supposedly",
  "Allegedly",
  "Practically",
  "Virtually",
  "Effectively",
  "Basically",
  "Essentially",
  "Fundamentally",
  "Primarily",
  "Chiefly",
  "Mostly",
  "Largely",
  "Predominantly",
  "Properly",
  "Really",
  "Very",
  "Mega",
  "Super",
  "Extra",
  "Madly",
  "Insanely",
  "Ridiculously",
  "Absurdly",
  "Wildly",
  "Bonkers",
  "Stone-Cold",
  "Spot On",
  "Bang On",
  "A Hundred Percent",
  "Probably",
  "Rumored To Be",
  "Statistically Likely To Be",
];

const zodiacSigns = [
  'Aries', 'Taurus', 'Gemini', 'Cancer', 'Leo', 'Virgo',
  'Libra', 'Scorpio', 'Sagittarius', 'Capricorn', 'Aquarius', 'Pisces'
];

// outside of the function so it doesn't change on re-render, but does change on page reload
const randomValue = Math.random();

const Horoscopes = () => {
  const horoscopeMessages = AppStore.useState(s => s.featureData?.horoscopes) || {};
  const randomSynonym = completelySynonyms[Math.floor(randomValue * completelySynonyms.length)];
  
  // Try to get the saved sign from the cookie, default to 'Aries' if not found
  const initialSign = Cookies.get('selectedHoroscopeSign') || 'Aries';
  
  const [selectedSign, setSelectedSign] = useState(initialSign);
  const [horoscope, setHoroscope] = useState(horoscopeMessages[initialSign]);

  useEffect(() => {
    setHoroscope(horoscopeMessages[selectedSign]);
    Cookies.set('selectedHoroscopeSign', selectedSign, { expires: 365 });
  }, [selectedSign, horoscopeMessages]);

  const handleSignChange = (event: any) => {
    setSelectedSign(event.target.value);
  };

  return (
    <div className="previewTile">
      <div className="featureTitle">{randomSynonym} Authentic Horoscopes</div>
      <div className="horoscopeContainer">
        <div className="horoscopeMessage">
          {horoscope}
        </div>
        <div className="signSelector">
          <select id="sign-dropdown" value={selectedSign} onChange={handleSignChange}>
            {zodiacSigns.map((sign) => (
              <option key={sign} value={sign}>
                {sign}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default Horoscopes;